import { createSlice } from "@reduxjs/toolkit";
import { fetchProfile, editUser } from "./thunk";

const initialState = {
  error: "",
  success: "",
  user: {},
  loading: false,
};

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: {
    resetProfileFlag(state) {
      state.success = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Profile Cases
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.success = "";
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.data;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Edit User Cases
      .addCase(editUser.pending, (state) => {
        state.success = "";
        state.error = "";
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.success = action.payload.msg;
        state.user = action.payload.data;
      })
      .addCase(editUser.rejected, (state, action) => {
        state.error = action.error.msg;
      });
  },
});

export const { resetProfileFlag } = ProfileSlice.actions;
export default ProfileSlice.reducer;
